import { render, staticRenderFns } from "./binllingList.vue?vue&type=template&id=58f5ee26&scoped=true&"
import script from "./binllingList.vue?vue&type=script&lang=tsx&"
export * from "./binllingList.vue?vue&type=script&lang=tsx&"
import style0 from "./binllingList.vue?vue&type=style&index=0&id=58f5ee26&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58f5ee26",
  null
  
)

export default component.exports